// ServiceNow Roles with acronyms for search
export const SERVICENOW_ROLES = [
  { id: 'dev', name: 'ServiceNow Developer', acronym: 'DEV' },
  { id: 'sdev', name: 'ServiceNow Senior Developer', acronym: 'SDEV' },
  { id: 'ldev', name: 'ServiceNow Lead Developer', acronym: 'LDEV' },
  { id: 'tc', name: 'ServiceNow Technical Consultant', acronym: 'TC' },
  { id: 'stc', name: 'ServiceNow Senior Technical Consultant', acronym: 'STC' },
  { id: 'ta', name: 'ServiceNow Technical Architect', acronym: 'TA' },
  { id: 'sa', name: 'ServiceNow Solution Architect', acronym: 'SA' },
  { id: 'pa', name: 'ServiceNow Platform Architect', acronym: 'PA' },
  { id: 'intdev', name: 'ServiceNow Integration Developer', acronym: 'INT' },
  { id: 'inta', name: 'ServiceNow Integration Architect', acronym: 'INTA' },
  { id: 'uiux', name: 'ServiceNow UI/UX Developer (UI Builder, Portal)', acronym: 'UI/UX' },
  { id: 'ae', name: 'ServiceNow Automation Engineer', acronym: 'AE' },
  { id: 'appdev', name: 'ServiceNow Application Developer (App Engine)', acronym: 'APP' },
  { id: 'lcdev', name: 'ServiceNow Low-Code Developer (App Engine Studio)', acronym: 'LC' },
  { id: 'fd', name: 'ServiceNow Flow Designer Specialist', acronym: 'FD' },
  { id: 'script', name: 'ServiceNow Scripting Specialist (GlideScript / JavaScript)', acronym: 'JS' },
  { id: 'fc', name: 'ServiceNow Functional Consultant', acronym: 'FC' },
  { id: 'ba', name: 'ServiceNow Business Analyst', acronym: 'BA' },
  { id: 'bpc', name: 'ServiceNow Business Process Consultant', acronym: 'BPC' },
  { id: 'pc', name: 'ServiceNow Process Consultant', acronym: 'PC' },
  { id: 'po', name: 'ServiceNow Process Owner', acronym: 'PO' },
  { id: 'prodowner', name: 'ServiceNow Product Owner', acronym: 'PROD' },
  { id: 'admin', name: 'ServiceNow Administrator', acronym: 'ADMIN' },
  { id: 'pmo', name: 'PMO / Project Manager', acronym: 'PMO' },
  { id: 'tl', name: 'Technical Lead', acronym: 'TL' }
];

// Flat role names for backward compatibility
export const SERVICENOW_ROLES_FLAT = SERVICENOW_ROLES.map(r => r.name);

// ServiceNow PRODUCTS - Complete list with categories
// These are the primary matching signal
export const SERVICENOW_PRODUCTS = [
  // IT Workflows
  { id: 'itsm', name: 'ITSM', fullName: 'IT Service Management', category: 'IT Workflows' },
  { id: 'itom', name: 'ITOM', fullName: 'IT Operations Management', category: 'IT Workflows' },
  { id: 'itam', name: 'ITAM', fullName: 'IT Asset Management', category: 'IT Workflows' },
  { id: 'spm', name: 'SPM', fullName: 'Strategic Portfolio Management', category: 'IT Workflows' },
  { id: 'irm', name: 'IRM', fullName: 'Integrated Risk Management', category: 'IT Workflows' },
  { id: 'secops', name: 'SecOps', fullName: 'Security Operations', category: 'IT Workflows' },
  
  // Customer Workflows
  { id: 'csm', name: 'CSM', fullName: 'Customer Service Management', category: 'Customer Workflows' },
  { id: 'fsm', name: 'FSM', fullName: 'Field Service Management', category: 'Customer Workflows' },
  { id: 'som', name: 'SOM', fullName: 'Service Order Management', category: 'Customer Workflows' },
  { id: 'somt', name: 'SOMT', fullName: 'Service Order Management for Telecom', category: 'Customer Workflows' },
  { id: 'omt', name: 'OMT', fullName: 'Order Management for Telecommunications', category: 'Customer Workflows' },
  
  // Employee Workflows
  { id: 'hrsd', name: 'HRSD', fullName: 'Human Resources Service Delivery', category: 'Employee Workflows' },
  { id: 'wsd', name: 'WSD', fullName: 'Workplace Service Delivery', category: 'Employee Workflows' },
  { id: 'lsd', name: 'LSD', fullName: 'Legal Service Delivery', category: 'Employee Workflows' },
  
  // Creator / Platform & Automation
  { id: 'platform', name: 'Now Platform', fullName: 'Now Platform', category: 'Creator / Platform & Automation' },
  { id: 'ae', name: 'App Engine', fullName: 'App Engine', category: 'Creator / Platform & Automation' },
  { id: 'ih', name: 'IntegrationHub', fullName: 'IntegrationHub', category: 'Creator / Platform & Automation' },
  { id: 'aeg', name: 'Automation Engine', fullName: 'Automation Engine', category: 'Creator / Platform & Automation' },
  { id: 'rpa', name: 'RPA', fullName: 'Robotic Process Automation Hub', category: 'Creator / Platform & Automation' },
  { id: 'pad', name: 'PAD', fullName: 'Process Automation Designer', category: 'Creator / Platform & Automation' },
  { id: 'fd', name: 'Flow Designer', fullName: 'Flow Designer', category: 'Creator / Platform & Automation' },
  
  // Data, Analytics & AI
  { id: 'pa', name: 'PA', fullName: 'Performance Analytics', category: 'Data, Analytics & AI' },
  { id: 'pi', name: 'PI', fullName: 'Predictive Intelligence', category: 'Data, Analytics & AI' },
  { id: 'va', name: 'VA', fullName: 'Virtual Agent', category: 'Data, Analytics & AI' },
  { id: 'genai', name: 'Now Assist / GenAI', fullName: 'Now Assist / GenAI', category: 'Data, Analytics & AI' },
  { id: 'pm', name: 'Process Mining', fullName: 'Process Mining', category: 'Data, Analytics & AI' },
  { id: 'oi', name: 'OI', fullName: 'Operational Intelligence', category: 'Data, Analytics & AI' },
  
  // Industry Solutions
  { id: 'tsm', name: 'TSM', fullName: 'Telecommunications Service Management', category: 'Industry Solutions' },
  { id: 'fso', name: 'FSO', fullName: 'Financial Services Operations', category: 'Industry Solutions' },
  { id: 'psds', name: 'PSDS', fullName: 'Public Sector Digital Services', category: 'Industry Solutions' },
  { id: 'mcw', name: 'MCW', fullName: 'Manufacturing Connected Workforce', category: 'Industry Solutions' },
  { id: 'hcls', name: 'HCLS', fullName: 'Healthcare & Life Sciences Service Management', category: 'Industry Solutions' },
  
  // Experience & UI
  { id: 'sp', name: 'SP', fullName: 'Service Portal', category: 'Experience & UI' },
  { id: 'ec', name: 'EC', fullName: 'Employee Center', category: 'Experience & UI' },
  { id: 'uib', name: 'UIB', fullName: 'UI Builder', category: 'Experience & UI' },
  { id: 'nm', name: 'Now Mobile', fullName: 'Now Mobile', category: 'Experience & UI' },
  { id: 'nx', name: 'NX / Polaris', fullName: 'Next Experience / Polaris', category: 'Experience & UI' },
  
  // Legacy / Common
  { id: 'cmdb', name: 'CMDB', fullName: 'Configuration Management Database', category: 'Core / Common' }
];

// ServiceNow MODULES organized by product
// These are more granular than products
export const SERVICENOW_MODULES_BY_PRODUCT = {
  'ITSM': [
    'Incident Management',
    'Major Incident Management',
    'Problem Management',
    'Change Management (standard/normal/emergency)',
    'Release Management',
    'Request Fulfillment / Request Management',
    'Service Catalog',
    'Knowledge Management',
    'Service Level Management (SLAs/OLAs/UCs)',
    'Service Portfolio (service offerings, etc.)',
    'Agent Workspace / ITSM Workspace'
  ],
  'ITOM': [
    'Discovery',
    'Service Mapping',
    'Event Management / Alerting',
    'ITOM Health (service health, impact)',
    'ITOM Optimization (cloud spend / optimization)',
    'AIOps'
  ],
  'ITAM': [
    'Hardware Asset Management (HAM)',
    'Software Asset Management (SAM / SAM Pro)',
    'Asset Lifecycle (procure-to-retire)',
    'Contracts & Entitlements'
  ],
  'CMDB': [
    'Data model & CI classes',
    'CI lifecycle governance',
    'Relationship & service modeling',
    'CSDM alignment / service portfolio alignment',
    'Data quality / reconciliation patterns',
    'Discovery integration & ingestion patterns'
  ],
  'SPM': [
    'Demand Management',
    'Project Portfolio Management (PPM)',
    'Resource Management (RM Workspace)',
    'Financial Planning / Budgeting',
    'Portfolio Planning / Strategic Planning / Goals framework',
    'Agile Development (Scrum / Agile 2.0)',
    'Test Management',
    'Innovation Management',
    'Collaborative Work Management'
  ],
  'CSM': [
    'Case Management',
    'Customer/Account/Contact & Data Management',
    'Agent Workspace (CSM workspace)',
    'Omnichannel (email/chat/telephony)',
    'Knowledge for Customer Service',
    'Service Portal / Customer Portal / Communities',
    'Field dispatch linkage (FSM)'
  ],
  'FSM': [
    'Work Order Management',
    'Dispatching & Scheduling',
    'Mobile Field Service',
    'Parts / Inventory',
    'Contractor Management'
  ],
  'SOM / SOMT / OMT': [
    'Order capture / order decomposition',
    'Orchestration / fulfillment flows',
    'Service activation / provisioning integrations',
    'Inventory/service resource modeling',
    'Assurance / fallout handling',
    'Catalog-driven fulfillment'
  ],
  'HRSD': [
    'HR Case Management',
    'Employee Service Center / HR Portal',
    'Lifecycle Events (onboarding, changes, offboarding)',
    'Document management / Knowledge HR',
    'HR integrations (Workday/SAP SuccessFactors etc.)'
  ],
  'WSD': [
    'Facilities / Workplace Case Management',
    'Space / reservations',
    'Workplace services catalog',
    'On-site service requests'
  ],
  'LSD': [
    'Legal intake / request management',
    'Matter management',
    'Contract workflows',
    'Knowledge / templates'
  ],
  'IRM': [
    'Policy & Compliance',
    'Risk Management',
    'Audit Management',
    'Vendor / Third-Party Risk',
    'Business Continuity'
  ],
  'SecOps': [
    'Security Incident Response (SIR)',
    'Vulnerability Response',
    'Threat Intelligence',
    'Integrations (SIEM/SOAR) & playbooks'
  ],
  'Platform / Creator': [
    'Data model / tables / ACLs',
    'UI (Forms/Lists), UI Policies, Client Scripts, Business Rules',
    'Flow Designer',
    'Notifications / Events',
    'Update Sets / App packaging',
    'Scoped apps',
    'App Engine Studio',
    'Experience / UI Builder',
    'IntegrationHub Spokes, Actions, REST/SOAP, MID Server patterns',
    'ETL patterns / imports',
    'Automation Engine / PAD / RPA',
    'Process Automation Designer',
    'RPA Hub',
    'Orchestration patterns'
  ],
  'Analytics / AI': [
    'Performance Analytics (KPIs, scorecards, breakdowns)',
    'Predictive Intelligence (classification, routing)',
    'Virtual Agent (topics, NLU, handoff)',
    'Now Assist / GenAI',
    'Process Mining (process discovery, conformance)',
    'Operational Intelligence'
  ]
};

// Flat list of all modules (for simple dropdown/search)
export const SERVICENOW_MODULES = Object.values(SERVICENOW_MODULES_BY_PRODUCT).flat();

// Security Clearance Levels
export const SECURITY_CLEARANCE_LEVELS = [
  { id: 'none', name: 'None', description: 'No security clearance' },
  { id: 'standard', name: 'Standard', description: 'Basic background check' },
  { id: 'enhanced', name: 'Enhanced', description: 'Enhanced clearance (e.g., SÜ2, SC)' },
  { id: 'high', name: 'High-Level', description: 'High-level security clearance (e.g., SÜ3, DV, TS)' }
];

// Countries for security clearance
export const CLEARANCE_COUNTRIES = [
  'France', 'Germany', 'United Kingdom', 'United States', 'Switzerland', 
  'Belgium', 'Netherlands', 'Luxembourg', 'Italy', 'Spain', 'Austria',
  'Canada', 'Australia', 'Other EU', 'Other'
];

// Other Certifications & Tools (non-ServiceNow)
export const OTHER_CERTIFICATIONS = [
  // ITIL
  'ITIL 4 Foundation',
  'ITIL 4 Managing Professional',
  'ITIL 4 Strategic Leader',
  'ITIL v3 Foundation',
  'ITIL v3 Intermediate',
  'ITIL v3 Expert',
  // Project Management
  'PMP (Project Management Professional)',
  'PRINCE2 Foundation',
  'PRINCE2 Practitioner',
  'Scrum Master (CSM)',
  'Product Owner (CSPO)',
  'SAFe Agilist',
  'SAFe Practitioner',
  'PMI-ACP',
  // Cloud & DevOps
  'AWS Solutions Architect',
  'AWS Developer',
  'AWS SysOps Administrator',
  'Azure Administrator',
  'Azure Developer',
  'Azure Solutions Architect',
  'Google Cloud Professional',
  'Kubernetes Administrator (CKA)',
  'Docker Certified Associate',
  'Terraform Associate',
  // Microsoft
  'Microsoft 365 Certified',
  'Microsoft Power Platform',
  'Microsoft Dynamics 365',
  'Microsoft SharePoint',
  // Development & Data
  'JavaScript Developer',
  'Python Developer',
  'Java Developer',
  'SQL Certified',
  'MongoDB Certified',
  // Security
  'CISSP',
  'CISM',
  'CompTIA Security+',
  'ISO 27001 Lead Auditor',
  'ISO 27001 Lead Implementer',
  // Tools
  'Jira Administrator',
  'Confluence Administrator',
  'Salesforce Administrator',
  'SAP Certified',
  // Other
  'TOGAF Certified',
  'Six Sigma Green Belt',
  'Six Sigma Black Belt',
  'COBIT Foundation'
];

// Product categories for grouping
export const PRODUCT_CATEGORIES = [
  'IT Workflows',
  'Customer Workflows',
  'Employee Workflows',
  'Creator / Platform & Automation',
  'Data, Analytics & AI',
  'Industry Solutions',
  'Experience & UI',
  'Core / Common'
];
